import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import AuthButton from 'components/base/AuthButton';
import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomListComponent from 'components/base/CustomListComponent';
import DeletePrompt from 'components/base/DeletePrompt';
import ListButtonsGroup from 'components/base/ListButtonsGroup';
import { DELETE_RELATED_SECTIONS } from 'config/CustomEnums';
import { NavBarNames } from 'config/NavBarNameList';
import { PermissionCodes } from 'config/PermissionCodes';
import BaseListContainer from 'containers/base/BaseListContainer';
import BaseTabListContainer from 'containers/base/BaseTabListContainer';

import { createAction } from 'utils';

function AdminGroupList() {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const { listFields, dataList, pageInfo, totalPage, totalCount, checkedList } =
    useSelector((state) => ({
      listFields: state.adminGroup.listDisplayFields,
      dataList: state.adminGroup.adminGroupList,
      pageInfo: state.adminGroup.pageInfo,
      totalPage: state.adminGroup.totalPage,
      totalCount: state.adminGroup.totalCount,
      checkedList: state.adminGroup.checkedList,
    }));
  const crateAdminGroupAction = () => {
    dispatch({ type: `adminGroup/clearData` });
    history.push('/administrator_groups/create');
  };
  const buttons = [
    <ListButtonsGroup
      hideExtraButtonWidth={580}
      hideAllButtonWidth={580}
      primaryButton={
        <AuthButton
          title="Create Permission Groups"
          action={crateAdminGroupAction}
          requires={PermissionCodes.addAdministratorGroup}
        />
      }
      primaryPopContent={{
        requires: PermissionCodes.addAdministratorGroup,
        action: crateAdminGroupAction,
        content: 'Create Permission Groups',
      }}
    />,
  ];

  const groupActions = [
    {
      name: 'Delete',
      action: () => {
        // setShowPrompt(true);
        setShowDeletePrompt(true);
      },
      requires: PermissionCodes.deleteAdministratorGroup,
    },
  ];

  const tabs = [
    // {
    //   name: 'Overview',
    //   content: <div>Overview</div>,
    // },
    {
      name: 'List of Customers',
      content: (
        <BaseTabListContainer
          hideTab={true}
          tabs={[]}
          groupActions={groupActions}
          pageInfo={pageInfo}
          totalCount={totalCount}
          listContent={
            <BaseListContainer
              fields={listFields}
              dataList={dataList}
              totalPage={totalPage}
              model={'adminGroup'}
              permissionGroup={PermissionCodes.administratorgroup}
              deleteInfo={{
                data: [],
                title: 'Permission Group',
                relatedName: '',
                onComfirm: {},
                relatedSections: DELETE_RELATED_SECTIONS.ADMIN_GROUP,
              }}
              actions={['Edit', 'Delete', 'Duplicate']}
            />
          }
        />
      ),
    },
  ];

  const [showDeletePrompt, setShowDeletePrompt] = useState(false);

  useEffect(() => {
    dispatch({ type: `adminGroup/clearData` });
    dispatch(
      createAction('adminGroup/getPagedAdminGroups')({
        page: 1,
        reverse: true,
        search: '',
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    const queryString = require('query-string');
    const searchDict = queryString.parse(location.search);
    const searchKey = queryString.parse(location.search)['search'];
    const stringRank = queryString.parse(location.search)['rank'] || 'true';
    const stringPage = queryString.parse(location.search)['page'] || 1;
    const rank = stringRank === 'true';
    const page = parseInt(stringPage);

    dispatch(
      createAction('adminGroup/getPagedAdminGroups')({
        page,
        reverse: rank,
        search: searchKey,
        moreSearch: { ...searchDict },
      }),
    );
  }, [dispatch, location]);

  return (
    <>
      <CustomListComponent
        caution={{
          detail:
            'Can create a Permission Group and give corresponding permissions.',
          title: NavBarNames.adminGroup,
        }}
        breadcrumb={<CustomBreadcrumb />}
        buttons={buttons}
        tabs={tabs}
        hideTab={true}
      />
      <DeletePrompt
        data={checkedList}
        title={'Permission Group'}
        relatedName={''}
        relatedSections={DELETE_RELATED_SECTIONS.ADMIN_GROUP}
        show={showDeletePrompt}
        onClose={() => setShowDeletePrompt(false)}
        onConfirm={() => {
          setShowDeletePrompt(false);
          dispatch(
            createAction('adminGroup/delete')({
              afterAction: () => {
                history.push(location);
              },
            }),
          );
        }}
      />
    </>
  );
}

export default AdminGroupList;
